import { INTEGRATION_TYPE_LABELS } from '@/components/CorporateUsers/modals/constants';

// INTEGRATION_TYPE_LABELS already includes dispatch_integration_types. A code with no
// entry is title-cased: underscores become spaces and each word is capitalized.
const fallbackLabel = (code) =>
    code
        .split('_')
        .filter((word) => word.length > 0)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');

export const integrationSourceLabel = (code) => INTEGRATION_TYPE_LABELS[code] || fallbackLabel(code);

// Generic channels share one icon. EDI stays uppercase; the rest of the known
// codes have a display name. Anything else uses the same title-case fallback.
const CHANNEL_LABELS = {
    EMAIL: 'Email',
    EDI: 'EDI',
    WERNER: 'Werner',
    TEAMS: 'Teams',
    CUSTOMER: 'Customer',
};

const channelSourceLabel = (code) => CHANNEL_LABELS[code] || fallbackLabel(code);

// One actor: a username, then an integration code, then a rejected code that
// was saved with source_integration null, then a channel. A channel is shown
// only when source_integration_provided is null. CUSTOMER is a channel, so it
// does not use the person icon. A historical row stays blank.
export const getActivityLogSource = (log) => {
    const username = log?.user?.username;
    if (typeof username === 'string' && username.trim() !== '') {
        return { label: username.trim(), kind: 'user' };
    }

    const integration = log?.source_integration;
    if (typeof integration === 'string' && integration.trim() !== '') {
        return { label: integrationSourceLabel(integration.trim()), kind: 'integration' };
    }

    const provided = log?.source_integration_provided;
    if (typeof provided === 'string' && provided.trim() !== '') {
        const code = provided.trim();
        return {
            label: 'Unknown',
            kind: 'integration',
            labelTooltip: `${code} was not added as an integration_types enum.`,
        };
    }

    const channel = log?.source_channel;
    if (typeof channel === 'string' && channel.trim() !== '') {
        return { label: channelSourceLabel(channel.trim()), kind: 'channel' };
    }

    return { label: '', kind: 'empty' };
};
